<script>
import i18n from "../i18n";
import { menuItems } from "./horizontal-menu";
import { anonymousMenuItems } from "./anonymous-Menu-Items";
import PartnerApi from "@/services/partner-api";
import SelectedCompaignModal from "@/components/SelectedCompaignModal";
import { mapGetters } from 'vuex';
import CampaignApi from "@/services/campaign-api";

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    
    return null;
}
 

/**
 * Nav-bar Component
 */
export default {
    components:{SelectedCompaignModal},

  computed: {
    
    ...mapGetters('menu', ['menuCampaign', 'customerName', 'customerLogo', 'hasMenuCampaignId']),

    permission() {
         const  storedPermissions = JSON.parse(getCookie('permission')) || [];
        return storedPermissions
        },

    notifPagesNbr() {
      return Math.ceil(this.notificationsCount / this.notifPageSize);
    },

    userShortName() {
      var short = this.$cookies.get('userFullName') /* this.$cookies.isKey('userFullName') ? this.$cookies.get('userFullName').split(' ')[0] : ''*/;      
      return short.length > 7 ? short.substring(0, 7) + '...' : short;
    },

    userFullName() {
      return this.$cookies.isKey('userFullName') ? this.$cookies.get('userFullName') : '';      
    },

    companyName() {
      return this.$cookies.isKey('companyName') ? this.$cookies.get('companyName').length > 10 ? this.$cookies.get('companyName').substring(0, 10) + '...' : this.$cookies.get('companyName') : '';   
    },

    fullCompanyName() {
      return this.$cookies.isKey('companyName') ? this.$cookies.get('companyName') : '';   
    },

    isSupplier() {
      return this.$cookies.get('userr') == 1;
    },

    isAdmin() {
      return this.$cookies.get('userr') == 2;
    },

    role() {
      return this.$cookies.get('userr');
    },

    draftOrderId() {
      return this.$cookies.isKey('drafto') ? this.$cookies.get('drafto') : null;
    },

    draftOrderLinesCount() {
      return this.$cookies.isKey('draftoc') ? this.$cookies.get('draftoc') : null;
    },
   
    isAnonymousRoute() {
        const currentPath = this.$route.path;
        return anonymousMenuItems.some(item => item.link === currentPath) || this.$route.name == 'demo';
      },
    
    isCustomerAdmin() {
        return this.$cookies.get("ica") === 'true' || this.$cookies.get("ica") === true;
      }
    

  },
  data() {
    return {
      showAnonymousMenu:false,
      languages: [
        {
          language: "fr",
          title: "French",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,

      keyword:"",
      supplierFullName:'',

      interval: null,

      notifications: [],
      notificationsCount: 0,
      notifPage: 1,
      notifPageSize: 3,

      selectedUserList:[],
      showUsersModal:false,

      showDraftOrder: false,

      menuItems: menuItems,
      anonymousMenuItems: anonymousMenuItems,
      countLastRequestQuote: null,
      openModal:false,

    };
  },

  created() {
      if(this.isSupplier){
        this.getCountLastRequestQuote()
        this.interval = setInterval(this.getCountLastRequestQuote, 60000)
      }
    },
    beforeDestroy () {
      clearInterval(this.interval);
    },

  mounted() {

     if(this.role == 0 || this.role == 1 ){
        this.initializeDefaultCampaignInStore()
     }

    this.$root.$on('order-changed-event', () => {
        this.$cookies.refresh()
    })

    this.$root.$on('order-submitted', () => {
        this.$cookies.refresh()
    })

    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;

  },

  methods: {

    initializeDefaultCampaignInStore(){

      if(this.hasMenuCampaignId){
        return
      }

      CampaignApi.findCampaignByCurrentCustomer(1, 5).then(result =>{
          if(result){
            const campaignList= result.list
            if(campaignList && campaignList.length){
              this.$store.dispatch("menu/setStateFromCampaign",campaignList[0]);
            }


          }
        })
    },
    scrollToElement(id) {
      if (this.$route.name !== 'default') {
      this.$router.push({ name: 'default' }).then(() => {
        this.$nextTick(() => {
        var elmnt = document.getElementById(id);
        elmnt.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      });
      } else {
      var elmnt = document.getElementById(id);
      elmnt.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },

  onMenuClick(link, id) {
      if (id) {
       this.scrollToElement(id)
      } else {
        this.$router.push({ path: link });
      }
    },

    showModal(){
      this.openModal = true
    },

    getCountLastRequestQuote() {

      PartnerApi.getCountLastRequestQuote()
      .then(result => {
        if (result) {
          this.countLastRequestQuote = result;
        }
      })
      },

    
    toggleMenu() {
      this.showAnonymousMenu = !this.showAnonymousMenu;
    },
    closeMenu() {
      this.showAnonymousMenu = false;
    },

    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country) {
      this.lan = locale;
      this.text = country;
      i18n.locale = locale;
    },

    toNotificationIcon(notificationType) {
      if (notificationType == null) {
        return;
      }
      switch (notificationType) {
        case 0: return "fas fa-dolly";
        case 1: return "fas fa-check-double";
        case 2: return "fas fa-truck-loading";
        case 3: return "fas fa-exclamation-triangle";
        case 4 : return "fas fa-file-invoice-dollar";
        default : return "fas fa-dolly";
      }
    },

    toNotificationColor(notificationType) {
      if (notificationType == null) {
        return;
      }
      switch (notificationType) {
        case 0: return "bg-danger";
        case 1: return "bg-info";
        case 2: return "bg-success";
        case 3: return "bg-secondary";
        case 4: return "bg-primary";
        default : return "bg-secondary";
      }
    },

    toPath(notificationType){
      if (notificationType == null) {
        return;
      }
      if(notificationType==0 || notificationType==1 || notificationType==2 || notificationType==3){
        return '/orders/order'
      }
    },

    toQuery(notif){
      if (notif == null) {
        return;
      }
      if(notif.type==0 || notif.type==1 || notif.type==2 || notif.type==3){
        return notif.orderId
      }

      if(notif.type==4){
        return null
      }
    },

    connect() {
      if(!this.userFullName) {
        this.$router.push({ name: "login" });
      }
    },

    onDraftModalClose() {
      this.$root.$emit('order-cart-modal-closed', true)
    },

    

  },

  watch :{

    '$route.query.filter': {
        handler: function(filter) {
          this.keyword = filter;
        },
        deep: true,
        immediate: true
    },
    
  }

  


};
</script>


<template>  
<div :class="$route.name != 'default'  ? 'navbar-header' : '' "  >
 
  <!-- style="border-bottom: 1px solid #f4f4f4;" #61b083ab  #d1e5d57a -->
  <header id="page-topbar" style="z-index: 1000;     box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);">
  <!-- <header id="page-topbar"  > -->


    <!-- LOGO BLOCK & MOBILE MENU BUTTON -->
    <div class="navbar-header"   >


      <div class="row w-100 m-sm-4 m-0 " >

        <div class="col-2 my-auto" v-if="isAnonymousRoute || this.$route.name === '404'">
          <img src="@/assets/images/header-logo.png" alt height="40" />
        </div>

        <div class="menu my-auto" :class="isAnonymousRoute || this.$route.name === '404' ? 'col-4 col-sm-6 col-md-7 col-lg-8' : 'col-12 text-right' ">

            <div v-if="userFullName && !isAnonymousRoute && this.$route.name !== '404'" class="menu-campaign-container" @click="showModal()">
                <!-- When menu is selected -->
                <template v-if="hasMenuCampaignId">
                  <!-- Logo -->
                  <div v-if="menuCampaign.customerLogo" class="logo-wrapper">
                    <img :src="'/api/image/get/' + menuCampaign.customerLogo" alt="logo" />
                  </div>

                  <!-- Text -->
                  <div class="text-wrapper">
                    <div class="customer-name">
                      {{ menuCampaign.customerName }}
                    </div>
                    <div class="menu-name">
                      {{ menuCampaign.menuName }}
                    </div>
                  </div>
                </template>

                <!-- When NO menu selected -->
                <template v-else>
                  <div class="no-menu-text">
                    Sélectionner un menu
                  </div>
                </template>
              </div>

              <ul v-else class="m-0 p-0 align-items-center d-none d-lg-flex">

                <li v-for="(item, index) in anonymousMenuItems"
                  :key="index"
                  :class="$route.name !== 'default' && $route.path === item.link ? 'active' : ''" 
                  style="margin-right: 15px;"
                > 
                
                  <div
                    class="text-uppercase font-weight-bold "
                    @click="onMenuClick(item.link, item.hash)"
                  >
                    {{ item.label }}
                  </div>
                </li>
              </ul>

        </div>

        <div  v-if="isAnonymousRoute || this.$route.name === '404'" class="col-6 col-sm-4 col-md-3 col-lg-2 my-auto text-right px-md-0 px-2">
              <!-- NOTIFICATIONS BUTTON + CART + LEFT USER BUTTON -->
              <div class="">

              <router-link
                :to="(isAdmin || isSupplier || isCustomerAdmin) ? '/analytics/sales' : '/settings/menu'"
                class="btn btn-secondary font-weight-bold px-4 py-1 d-none d-lg-inline-flex align-items-center"
              >
                {{userFullName ? userFullName :'Espace Client'}}
              </router-link>

              <!-- MOBILE / TABLET -->
              <div class="d-inline-block d-lg-none position-relative">
                <button
                  class="btn btn-secondary font-weight-bold py-1"
                  @click="toggleMenu"
                >
                  ☰
                </button>

                <div
                  v-if="showAnonymousMenu"
                  class="dropdown-menu dropdown-menu-right fancy-dropdown show"
                >

                  <router-link
                    to="/analytics/sales"
                    class="dropdown-item d-flex align-items-center font-weight-bold"
                    @click.native="closeMenu"
                  >
                    Espace Client
                  </router-link>

                <div class="dropdown-divider"></div>


                  <router-link
                    v-for="item in anonymousMenuItems"
                    :key="item.id"
                    :to="item.link"
                    class="dropdown-item d-flex align-items-center"
                    @click.native="closeMenu"
                  >
                    {{ item.label }}
                  </router-link>
                </div>
              </div>

              </div>
              <!-- END NOTIFICATIONS BUTTON + CART + LEFT USER BUTTON  -->
        </div>


      </div>

    </div>

  </header>


  <b-modal
    id="location-permission-modal"
    v-model="openModal"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    size="ld"
    :modal-class="'high-z-modal'"
  >

  <div class="text-right" @click="openModal = false">
    <img  alt="close"  width="17px" src="@/assets/icons/close-danger.svg" style="cursor: pointer;"  />
  </div>


  <SelectedCompaignModal @closeModal="openModal = false"/>
  

  </b-modal>
</div>

</template>


<style scoped>
.high-z-modal {
  z-index: 999999 !important; /* higher than your sidebar */
}


.menu-mobile {
  width: 100%;
  background-color: #fff; 
  position: fixed;
  top: 0;
  z-index: 1000; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 5px;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: block;
    flex-direction: column; 
    justify-content: space-between;
    height: 100%;

    li {
      padding: 15px 20px;
      text-align: left;
      font-size: 1rem;
      transition: background-color 0.3s ease, color 0.3s ease;

      &.active {
        background-color: #f0f0f0;
        font-weight: bold;
        border-left: 4px solid #1d3266;
      }

      &:hover {
        background-color: #e9ecef;
      }

      .text-dark {
        color: #333;
        text-decoration: none;
      }

      .text-uppercase {
        text-transform: uppercase; 
      }
    }
  }

  a {
    color: inherit; 
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  @media (min-width: 768px) {
    ul {
      flex-direction: row; 
    }

    li {
      padding: 10px 15px; 
    }
  }
}

.circular-badge {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 10px;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 5px rgba(255, 0, 0, 0.5);
}


</style>



<style>
  /* .navbar-header .dropdown.show .header-item {
    background-color: #5cb45b;
} */

    .navbar-header .mobile-user-button .dropdown .dropdown-menu {
        left: 10px !important;
        right: 10px !important;
        min-width:300px;
    }

    @media all and (max-width: 1024px) and (min-width: 1024px) {
    #logo {
        padding-left: 20px;
    } 

    }


  
    .menu {
      overflow-x: scroll;
      overflow-y: hidden; 
      white-space: nowrap;
      width: 100%;
      height: 100%; 
      -ms-overflow-style: none; 
      scrollbar-width: none;
      -webkit-overflow-scrolling: touch;
    }

    .menu::-webkit-scrollbar {
      display: none; /* hide scrollbar on Chrome and Safari */
    }

    .menu:active {
      cursor: grab;
      cursor: -webkit-grab;
    }

    .menu:active::-webkit-scrollbar-thumb {
      background-color: #ddd;
    }

    .menu:active::-webkit-scrollbar-track {
      background-color: #f1f1f1;
    }

    .menu ul {
      display: flex; /* use flexbox to make menu items expand to fill available space */
      align-items: stretch; /* stretch menu items to the full height of the menu */
    }

    .menu li {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  /*border-bottom: 3px solid white;*/
  /*border-top: 3px solid white;*/
  cursor: pointer;
  position: relative;
}

/* .menu li a:hover {
  color: #00acc8 !important;
} */

.menu li.active a,
.menu li.active,
.menu li:hover {
  /*border-bottom: 3px solid #1d3266;*/
  color: #D4AF37 !important;
}

.menu li {
  /*border-bottom: 3px solid #1d3266;*/
  color: #1d3266 !important;
}

.menu_title {
  color: white !important;
  text-shadow: 
    2px 2px 4px rgba(29, 185, 100, 0.5), 
    -2px -2px 6px rgba(0, 255, 255, 0.8);
}


.menu_title:hover {
  /*background-color: #ddd;*/
  color: #cfcece !important;
}


.menu li a {
  display: flex; /* enable flexbox layout */
  align-items: center; /* center link content vertically */
  justify-content: center; /* center link content horizontally */
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-decoration: none;

  color: #333;
  text-decoration: none;
      font-size: 14px;
      font-weight: bold;
}

menu ul {
      display: inline-block;
      list-style-type: none;
      margin: 0;
      padding: 0;
    }

  

</style>



<style>

.menu-campaign-container {
  display: inline-flex;
  align-items: center;
  gap: 10px;

  padding: 6px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;

  cursor: pointer;
  background-color: #fff;

  max-width: 260px;
}

.menu-campaign-container:hover {
  border-color: #0d6efd;
  background-color: #f8f9fa;
}

.logo-wrapper img {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  object-fit: contain;
}

.text-wrapper {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.customer-name {
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-name {
  font-size: 12px;
  color: #6c757d;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.no-menu-text {
  font-size: 13px;
  font-weight: 500;
  color: #6c757d;
}


</style>




<style>


.fancy-dropdown {
  min-width: 220px;
  border-radius: 12px;
  padding: 8px 0;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.fancy-dropdown .dropdown-item {
  padding: 10px 20px;
  font-weight: 600;
  transition: all 0.25s ease;
}

.fancy-dropdown .dropdown-item:hover {
  background-color: rgba(249, 212, 6, 0.15);
  color: #181711;
  transform: translateX(5px);
}

.menu-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}


</style>